{{ totalCost | currency: product.currency }}
<rt-divider variant="dot" />
{{ intervalText }}
